import purchaseOrderTypeService from "../../../../services/procurementService/purchaseOrderTypeService";
import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERTYPES } from "../../../../utils/constants";
import { PurchaseOrderTypeInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";

const usePurchaseOrderTypes = (page: number, pageSize: number) =>
  useQuery<PurchaseOrderTypeInterface[], Error>({
    queryKey: [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
    queryFn: () => purchaseOrderTypeService.GetAll(page, pageSize),
    initialData: [],
  });

export default usePurchaseOrderTypes;
